import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CardObjectSearchRequest, CardObject, PagedResponse } from '@core/api';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CardObjectService {

  constructor(private http: HttpClient) { }

  search(request: CardObjectSearchRequest): Observable<PagedResponse<CardObject>> {
    return this.http.post<PagedResponse<CardObject>>(environment.apiUrl + '/api/CardObject/Cards', request);
  }

}
